export default "__VITE_ASSET__Z_Kwyb6b__"